<template>
  <section class="adjust-policy">
    <h2>Adjust Policy</h2>
    <p v-if="isNext && isRefer">New premium could not be calculated automatically, please enter manually.</p>

    <div class="abs-top-right">
      <v-button
        gray
        @click="handlerCancel">Cancel</v-button>
      <v-button
        v-if="isNext&&!isPremium"
        red
        @click="handlerPremium(true)">Edit Premium</v-button>
      <v-button
        green
        @click="handlerNext">Next
      </v-button>
    </div>
    <section v-show="!isNext">
      <!--    //家佣-->
      <endorse-housemaid-policy-form
        v-if="productId !== 11"
        ref="housemaid-policy-form"
        :form="formData"
        :isAdjust="isAdjust"
        @submit="getHouseMaidData"
      />
      <policy-form
        v-else
        ref="policy-form"
        :form="formData"
        :isAdjust="isAdjust"
        @submit="getSubmitForm"/>

      <lazy-dom notLoading>
        <use-personal-data
          ref="use-personal-data"
          :marketing_data="formData.marketing_data"
          :company_name="formData.company_language"
          @sendData="getData"></use-personal-data>
      </lazy-dom>
    </section>

    <section v-if="isNext">
      <adjust-premium
        v-if="isPremium"
        ref="adjust-premium"
        :form="formData"
        :oldForm="oldForm"
        :premium-data="premiumData"
        :classId="formData.class_id"
        :productId="productId"
        :remarkList="remarkList"
        :orderId="orderId"
        :isRefer="isRefer"
        @get-quote="handlerGetQuoteUpdate"
        @getFormData="getPremiumForm"></adjust-premium>
      <adjust-policy-info
        v-else
        ref="adjust-policy-info"
        :form="formData"
        :oldForm="oldForm"
        :quote-coverage-list="quote_coverage_list"
        :premium="premiumData"
        :premiumArr="premiumArr"
        :isRefer="isRefer"
        @submit="getSubmitPremiumForm"/>
    </section>

    <adjust-refund
      ref="adjust-refund"
      :orderId="orderId"
      :formData="formData"
      :premiumForm="premiumForm"
      :premiumData="premiumForm"
      :dialogType="dialogType"
      @done="handlerAdjustRefundDone"/>
    <set-void-quote
      ref="void-dialog"
      :orderId="orderId"
      :is-normal="false"
      :refund="difference "
      :type="3"
      @setVoid="handlerVoidDone"
    ></set-void-quote>
    <set-void-quote
      ref="void-adjust-dialog"
      :orderId="orderId"
      :type="3"
      @setVoid="handlerVoidComplete"
    >
    </set-void-quote>
    <adjust-policy-dialog
      ref="adjust-dialog"
      :type="type"
      @void="handlerVoid"
      @premium="handlerPremium"
      @dontEdit="handleDontEdit"
      @return="handlerReturnPolicy"></adjust-policy-dialog>
    <edit-preimum-dialog
      v-model="showEidtPreimum"
      @premium="handlerPremium"
      @next="handleNotNow">

    </edit-preimum-dialog>
  </section>
</template>
<script>
import PolicyForm from './form/policy-form'
import AdjustPolicyInfo from './adjust-policy-info'
import AdjustPremium from './adjust-preimum'
import AdjustRefund from './dialog/adjust-refund'
import EndorseHousemaidPolicyForm from '../../../tickets/components/modules/housemaid/endorse-housemaid-policy-form'

import {getAdjustEditResult, getAdjustQuoteResult,saveAdjustEdit} from '@/api/endorsement'
import setVoidQuote from '@/views/components/set-void-quote'
import adjustPolicyDialog from '@/views/components/adjustPolicyDialog'
import editPreimumDialog from '@/views/components/editPreimumDialog'
import dayjs from 'dayjs'
import UsePersonalData from '@/views/components/use-personal-data'
import MixinOptions from '@/mixins/options'

export default {
  name: 'AdjustPolicy',
  components: {
    PolicyForm,
    AdjustPolicyInfo,
    AdjustRefund,
    EndorseHousemaidPolicyForm,
    setVoidQuote,
    adjustPolicyDialog,
    UsePersonalData,
    AdjustPremium,
    editPreimumDialog
  },
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    remarkList: {
      type: Array,
      default: () => ([])
    },
    isAdjust:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      oldForm: {},
      premiumData: {
        diff_payable: {},
        new_premium: {},
        old_premium: {},
        extra_benefits_premium: {},
        type: 1,
        is_manual_quote: 1
      },
      premiumArr: [],
      step: 0,
      isNext: false,
      isRefer: false,
      showEidtPreimum: false,
      normalEditPremium: false,
      isPremium: false,
      premiumForm: {},
      dialogType: 0,
      difference:0,
      successData:{},
      personalData: {},
      type:'',
      quote_coverage_list:{}
    }
  },
  computed: {
    orderId() {
      return this.form.id
    },
    productId(){
      return this.form.product_id
    },
    isFina() {
      return this.form.merchant_platform ==2
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
        this.oldForm = JSON.parse(JSON.stringify(val))
        this.oldForm.isrd_dob = dayjs(this.oldForm.isrd_dob).format('YYYY-MM-DD')
      }
    },
    'formData.occ_id':{
      handler(val){
        const {class_id} = this.formData
        let occList = []
        if(class_id === 14) {
          occList =  this.allOptions.occupation || []
        } else {
          occList =  this[`allOptions${class_id}`].occupation || []
        }
        let occ = this.getOptionName('occ',val, occList)
        this.formData.occ = occ
      }
    }
  },
  methods: {
    handleDontEdit(){
      let params = {
        not_edit_prm:1
      }
      let premium = this.premiumData||{}
      premium.benefits = JSON.parse(JSON.stringify(this.formData.benefits))
      premium.benefit_coverage = JSON.parse(JSON.stringify(this.formData.benefit_coverage))
      premium.benefit_sort = JSON.parse(JSON.stringify(this.formData.benefit_sort))
      this.network().saveAdjustEdit({...params,premium})
    },
    changeDiffPayble(payable) {
      this.diffPayable = payable
    },
    changeHandlingFee(handlingFee) {
      this.handlingFee = handlingFee
    },
    handlerGetQuoteUpdate(premiumForm) {
      let data = JSON.parse(JSON.stringify(this.formData))
      const params = Object.assign(data, premiumForm)
      this.network().getAdjustQuoteResult({
        get_quote_main: 1, // refer
        ...params
      })
    },
    getPremiumForm(premium, type, otherForm = {}) {
      this.formData.plan_id = premium.plan_id
      premium.benefits = JSON.parse(JSON.stringify(this.formData.benefits))
      premium.benefit_coverage = JSON.parse(JSON.stringify(this.formData.benefit_coverage))
      premium.benefit_sort = JSON.parse(JSON.stringify(this.formData.benefit_sort))
      // 拼接調用 save 接口
      const params = {
        premium,
        application: {
          ...this.formData,
          order_id: this.orderId,
          ...otherForm,
          is_manual_quote: premium.is_manual_quote,
          benefit_premium: premium.benefit_premium,
          edit_premium:1,
          marketing_data: this.personalData,
        }
      }
      this.$set(params.application, 'extra_benefits_content', this.premiumData.extra_benefits_premium)
      this.network().saveAdjustEdit(params)
    },
    handlerPremium(isNormal=false){
      this.isNext = true
      this.isPremium = true
      this.normalEditPremium = isNormal
      let params = JSON.parse(JSON.stringify(this.formData))
      delete params.benefit_coverage
      delete params.benefit_premium
      this.network().getAdjustQuoteResult(params,true)
    },
    handleNotNow(){
      this.isRefer = false
      this.isNext = true
      this.isPremium = false
    },
    handlerReturnPolicy(){
      this.$emit('cancel')
    },
    handlerVoid(){
      this.$refs['void-adjust-dialog'].changeDialog()
    },
    handlerVoidComplete(){
      this.$emit('handlerRefresh')
    },
    handlerNext() {
      if (!this.isNext) {
        if (this.productId !== 11) {
          this.$refs['housemaid-policy-form'].submitForm()
        } else
        {
          this.$refs['policy-form'].submitForm()
        }
      } else {
        if(this.isPremium)
        {
          this.$refs['adjust-premium'].submitForm()
        }else
          this.$refs['adjust-policy-info'].submitForm()
      }
    },
    handlerCancel() {
      if (!this.isNext) {
        this.$emit('cancel')
      } else {
        if(this.normalEditPremium){
          this.isPremium = false
          this.normalEditPremium =false
        }else
          this.isNext = false
      }
    },
    handlerAdjustRefundDone(data) {
      this.$emit('success', this.successData)
    },
    getSubmitPremiumForm(formData) {
      const {company_id, class_id, trm_of_cvr} = this.formData
      this.premiumForm = {
        ...formData,
        company_id,
        class_id,
        trm_of_cvr
      }
      // 分析是 refund 還是 need payment or no different
      const {difference} = formData
      this.difference = difference
      if (difference == 0) {
        this.dialogType = 0
        this.network().saveAdjustEdit()
      } else if (difference > 0) {
        this.dialogType = 2
        this.$refs['adjust-refund'].changeDialog()
      } else {
        this.dialogType = 1
        this.$refs['void-dialog'].changeDialog(difference)
      }
    },
    getSubmitForm(formData) {
      this.formData = Object.assign(this.formData, formData)
      this.network().getAdjustEditResult()
    },
    // 获取到家政信息
    getHouseMaidData(data) {
      data.pcy_cmnt_date = dayjs(data.pcy_cmnt_dt).format('DD-MM-YYYY 00:00')
      data.pcy_expry_date = dayjs(data.pcy_expry_dt).format('DD-MM-YYYY 23:59')
      this.formData = Object.assign(this.formData, data)
      this.network().getAdjustEditResult()
    },
    handlerVoidDone(data){
      this.network().saveAdjustEdit(data)
    },
    getData(personalData){
      this.personalData = personalData
    },
    network() {
      return {
        getAdjustEditResult: async () => {
          this.$refs['use-personal-data'].handleSendData()
          const plan_id  = this.formData.quote_coverage_list.plan_info.plan_id||''
          const {data} = await getAdjustEditResult({
            ...this.formData,
            order_id: this.formData.id,
            plan_id,
            marketing_data: this.personalData
          })
          const {quote_coverage_list,type, premium = {},premium_arr=[]} = data
          // refer 了
          if ([2,3,4].includes(type)) {
            this.type = type
            this.$refs['adjust-dialog'].changeDialog()
            // this.isRefer = true
          } else {
            this.quote_coverage_list = quote_coverage_list
            this.premiumData = premium
            this.premiumArr = premium_arr||[]
            this.isRefer = false
            this.isNext = true
            this.isPremium = false
          }

        },
        saveAdjustEdit: async (params = {}) => {
          // 退款類型 1：Credit; 2: Cheque (退款時必傳)
          delete this.formData.credit
          const {data} = await saveAdjustEdit({
            application: {
              ...this.formData,
              order_id: this.orderId,
              marketing_data: this.personalData
            },
            premium: this.premiumForm,
            ...params
          })
          // this.$emit('success', data.data)
          // this.dialogType = 0
          this.successData = data.data
          this.$refs['adjust-refund'].changeDialog()
        },
        getAdjustQuoteResult: async (params,isFirst=false) => {
          params.plan_id  = this.formData.quote_coverage_list.plan_info.plan_id||''
          const { data } = await getAdjustQuoteResult({
            ...params,
            order_id: this.orderId,
            marketing_data: this.personalData,
            is_manual_quote:isFirst?0:1
          })
          const { type, diff_payable, new_premium, old_premium, extra_benefits_premium, is_manual_quote } = data
          // this.isRefer = type === 2? true: false
          this.isNext = true

          this.premiumData = {
            diff_payable,
            new_premium,
            old_premium,
            extra_benefits_premium,
            type: type,
            is_manual_quote
          }
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.adjust-policy {
  position: relative;

  h2 {
    padding-bottom: 5px;

    & + p {
      padding-bottom: 10px;
    }
  }

  .dialog-container {
    padding: 15px;

    p {
      padding-bottom: 10px;
    }

    .dialog-footer {
      margin: 15px -15px -15px;
      padding: 15px;
      text-align: right;
      background: #F9FAFB;
    }
  }
}
</style>
